__webpack_require__.p = "/synthetic-data-generator/dashboard-demo/build/";